<app-tool-loader [isLoading]="isLoading()" [positionUnset]="true">
  <p-confirmDialog header="Confirmation" closable="false" icon="pi pi-exclamation-triangle"></p-confirmDialog>

<p-dialog class="container" header="Notice" [(visible)]="displayAnnContentsInfo" [draggable]="false" [closable]="false" appendTo="self">
  <p>Note: Please make sure that Annulus Contents are populated correctly after this change.</p>

  <div class="p-d-flex p-jc-end mt-3 text-right">
    <p-button label="OK" (onClick)="displayAnnContentsInfo = false"></p-button>
  </div>
</p-dialog>

  <div>
    <label>
      Total Well Depth: {{ totalDepth?.measuredDepth | number: '1.0-2' }} {{ longLengthUnit }} MD
    </label>
    <span>
      <i pTooltip="Note: Pipe, Grade and Connections will be copied into the well configuration from catalogs. If a Pipe, Grade or Connection is removed from the catalog, it will remain in the design.&#13;The design is valid and can be used without issue. It will be shown as (local only) in the Well Configuration." class="pi pi-info-circle cursor-help relative z-[2]"></i>
    </span>
  </div>

  <div class="overflow-auto">

      <form [formGroup]="wellConfigForm" novalidate>
        <p-contextMenu #cm [model]="contextMenuItems" appendTo="body"></p-contextMenu>
        <ng-container formArrayName="wellComponents">
          <p-table
          [appAutoTableHeight]="true"
          [appAutoTableHeightContainerSelector]="'.grid-stack-item-content'"
          [appAutoTableHeightOffset]="70"
          (appAutoTableHeightChange)="tableHeight = $event"
          [columns]="cols"
          [resizableColumns]="true"
          [value]="wellComponents?.controls"
          dataKey="value.id"
          rowExpandMode="single"
          [contextMenu]="cm"
          stateStorage="local"
          stripedRows
          [stateKey]="componentId"
          [expandedRowKeys]="expandedRows"
          >
            <ng-template #header let-columns>
              <tr>
                <th>
                  Strings
                </th>
                @for (col of columns; track $index) {
                <th pResizableColumn>
                  {{ col.header }}
                </th>
                }
                <th class="place-items-center">
                  <p-button class="min-w-[70px] outlined-button" size="small" [outlined]="true" severity="success" 
                    [disabled]="this.wellComponents.invalid" label="Add String" (click)="onAddWellComponent()">
                  </p-button>
                </th>
              </tr>
            </ng-template>

            <ng-template #body let-wellCmpFg let-wIdx="rowIndex" let-expanded="expanded">
              <ng-container [formGroupName]="wIdx">
                <tr [pContextMenuRow] (mouseover)="getRowIndex(wIdx, wellCmpFg)" (dblclick)="stringSectionsExpand(expanded, wIdx)" [ngStyle]="wIdx === selectedStringIndex ? {'background-color': 'color-mix(in srgb, var(--p-primary-color) 30%, var(--p-datatable-row-background))', 'box-shadow': 'inset 3px 0 0 var(--p-primary-color)'} : {'background-color': 'var(--p-datatable-row-background)'}">
                  <td [pTooltip]="getStringSectionsTextHintHover(wellCmpFg)">
                    @if (!userRoles.readOnly) {
                      <p-button 
                          text
                          size="small"
                          [icon]="expanded ? 'pi pi-chevron-up' : 'pi pi-chevron-down'"
                          [disabled]="isControlInvalid(wellCmpFg, 'holeSize')"
                          type="button" 
                          [pRowToggler]="wellCmpFg"
                          (click)="stringSectionsExpand(expanded, wIdx)"
                        >
                      </p-button>
                    }
                    @if (userRoles.readOnly) {
                      <i
                        [pRowToggler]="wellCmpFg"
                        (click)="stringSectionsExpand(expanded, wIdx)"
                        tabindex="0"
                        [class]="expanded ? 'pi pi-chevron-up' : 'pi pi-chevron-down'"
                      ></i>
                    }
                    @if (!wellCmpFg.controls.shoeMd.pristine && (!wellCmpFg.controls.holeSize.pristine || wellCmpFg.value.type == 'Tubing' || wellCmpFg.value.type == 'Tieback')) {
                      <app-validation-error [isValid]="wellCmpFg.invalid" [errorMsg]="getControlErrors(wellCmpFg)" pTooltip="Expand for Errors"/>
                    }
                    @if (!wellCmpFg.invalid) {
                      <label>{{ getStringSectionsTextHint(wellCmpFg) }}</label>
                    }
                  </td>
                  <td>
                    <p-select (onChange)="onStringTypeChange($event, wellCmpFg, wIdx)" class="w-[90%] min-w-[70px]" [disabled]="userRoles.readOnly" [options]="stringTypes" formControlName="type" appendTo="body" pTooltip="Type"></p-select>
                  </td>
                  <td>
                    <div class="w-[95%] flex items-center space-x-0.5">
                      <p-inputNumber  class="w-full" formControlName="hangerMd" [minFractionDigits]="1" [maxFractionDigits]="5" pTooltip="Hanger MD"></p-inputNumber>
                      @if (wellType == 'Subsea' && wellCmpFg.value.sequenceNumber != 0 && (wellCmpFg.value.type == 'Tubing' || wellCmpFg.value.type == 'Casing' || wellCmpFg.value.type == 'Tieback')) {
                        <p-button text size="small" severity="primary" [title]="wellCmpFg.get('hangerMd').value == 0 ? `Set to Wellhead \nSubsea wells: casing, tieback and tubing may be landed at mudline hanger or at surface.` : `Set to 0 ` + longLengthUnit + `\nSubsea wells: casing, tieback and tubing may be landed at mudline hanger or at surface.`" icon="pi pi-sort-alt" (click)="tubingHangerChange(wellCmpFg)"></p-button>
                      }
                      <app-validation-error [isValid]="isControlInvalid(wellCmpFg, 'hangerMd')" [errorMsg]="getControlErrors(wellCmpFg,'hangerMd')"/>
                    </div>
                  </td>
                  <td>
                    <div class="w-[95%] flex items-center space-x-2">
                      <p-inputNumber formControlName="shoeMd" [minFractionDigits]="1" [maxFractionDigits]="5" pTooltip="Shoe MD"></p-inputNumber>
                      @if (!wellCmpFg.controls.shoeMd.pristine) {
                        <app-validation-error [isValid]="isControlInvalid(wellCmpFg, 'shoeMd')" [errorMsg]="getControlErrors(wellCmpFg,'shoeMd')"/>
                      }
                    </div>
                  </td>
                  <td>
                    <div class="w-[95%] flex items-center space-x-2">
                      <p-inputNumber formControlName="holeSize" [minFractionDigits]="2" title="Hole Size"></p-inputNumber>
                      @if (!wellCmpFg.controls.holeSize.pristine) {
                        <app-validation-error [isValid]="isControlInvalid(wellCmpFg, 'holeSize')" [errorMsg]="getControlErrors(wellCmpFg,'holeSize')"/>
                      }
                    </div>
                  </td>
                  <td>
                    <div class="w-[95%] flex items-center space-x-2">
                      <span class="scale-75">
                        <p-checkbox
                          size="small" 
                          pTooltip="Has Cement"
                          binary="true"
                          formControlName="hasCement"
                        ></p-checkbox>
                      </span>
                      <p-inputNumber class="form-control" [minFractionDigits]="1" [maxFractionDigits]="5" formControlName="topOfCementMd" title="Top of Cement MD"></p-inputNumber>
                      <app-validation-error [isValid]="isControlInvalid(wellCmpFg, 'topOfCementMd')" [errorMsg]="getControlErrors(wellCmpFg,'topOfCementMd')"/>
                    </div>
                  </td>
                  <td>
                    <p-select
                      filter
                      filterBy="label"
                      resetFilterOnHide="true"
                      class="w-full"
                      [disabled]="userRoles.readOnly"
                      title="Annular Fluid"
                      placeholder="Select"
                      [options]="fluids"
                      formControlName="annularFluidId"
                      appendTo="body"
                      (onChange)="onAnnularFluidChange(wellCmpFg)">
                    </p-select>
                    <app-validation-error [isValid]="isControlInvalid(wellCmpFg, 'annularFluidId')" [errorMsg]="getControlErrors(wellCmpFg,'annularFluidId')"/>
                  </td>
                  <td class="text-center">
                    <p-button text size="small" severity="danger" pTooltip="Remove String" icon="pi pi-trash" (click)="onDeleteWellComponent(wIdx, wellCmpFg)"></p-button>
                  </td>
                </tr>
              </ng-container>
            </ng-template>

            <ng-template #expandedrow let-wellCmpFg>
              <tr>
                <td colspan="9">
                <div class="ui-g ui-fluid pl-2 pr-2">
                  <p-table
                  showGridlines
                  [value]="getWellComponentTubulars(wellCmpFg).controls"
                  [resizableColumns]="true"
                  [columns]="tubularCols"
                  dataKey="id"
                  >
                    <ng-container [formGroup]="wellCmpFg">
                      <ng-container formArrayName="stringSections">
                      <ng-template #header let-columns>
                        <tr>
                          <th>
                            Sections
                            @if (isControlInvalid(wellCmpFg, 'stringSections')) {
                              <app-validation-error style="padding-left: 5px;" [isValid]="isControlInvalid(wellCmpFg, 'stringSections')" [errorMsg]="getControlErrors(wellCmpFg,'stringSections')"/>
                            }
                        </th>
                          @for (col of columns; track $index) {
                          <th pResizableColumn>
                            {{ col.header }}
                          </th>
                          }
                          <th pResizableColumn [ngStyle]="{'width':'50px'}">
                          </th>
                        </tr>
                      </ng-template>
                      <ng-template #body let-tIdx="rowIndex" let-rowData>

                        <tr [style.backgroundColor]="'var(--p-datatable-row-selected-background)'" [formGroupName]="tIdx">
                          <td>
                            <div class="flex items-center justify-center space-x-3">
                              <p-button text size="small" severity="secondary" pTooltip="Insert section above" icon="pi pi-angle-up" (click)="onAddTubular(wellCmpFg, tIdx, false)"></p-button>
                              <p-button text size="small" severity="secondary" pTooltip="Insert section below" icon="pi pi-angle-down" (click)="onAddTubular(wellCmpFg, tIdx, true)"></p-button>
                            </div>
                          </td>
                          <td>
                            <p-inputNumber [class.opacity-50]="tIdx == wellCmpFg.get('stringSections').length - 1" [class.pointer-events-none]="tIdx == wellCmpFg.get('stringSections').length - 1" [minFractionDigits]="1" formControlName="bottomMeasuredDepth"></p-inputNumber>
                            <app-validation-error [isValid]="isControlInvalid(rowData, 'bottomMeasuredDepth')" [errorMsg]="getControlErrors(rowData,'bottomMeasuredDepth')"/>
                          </td>
                            <ng-container formGroupName="pipe">
                              <td>
                                <div class="flex w-full items-center gap-1 flex-nowrap">
                                  <app-units-select-input
                                    class="w-full"
                                    [unit]="units.shortLengths"
                                    [unitPrecisionOverrides]="pipeDimensionPrecisionOverrides()"
                                    optionLabel="value"
                                    optionValue="value"
                                    [readOnly]="userRoles.readOnly"
                                    [placeholder]="getPlaceholderText(rowData.get('pipe').value, 'outsideDiameter', rowData.get('bottomMeasuredDepth'), 'pipe')"
                                    [options]="rowData.get('odOptions').value"
                                    formControlName="outsideDiameter"
                                    (onChange)="resetConnection(wellCmpFg, tIdx)"
                                    appendTo="body">
                                  </app-units-select-input>
                                  <app-validation-error [isValid]="isControlInvalid(rowData.get('pipe'), 'outsideDiameter')" [errorMsg]="getControlErrors(rowData.get('pipe'), 'outsideDiameter')"/>
                                </div>
                              </td>

                              <td>
                                <div class="flex w-full items-center gap-1 flex-nowrap">
                                  <app-units-select-input
                                    class="w-full"
                                    [unit]="units.linearDensity"
                                    [unitPrecisionOverrides]="wpfPrecisionOverrides()"
                                    [readOnly]="userRoles.readOnly"
                                    [placeholder]="getPlaceholderText(rowData.get('pipe').value, 'weightPerFoot', rowData.get('bottomMeasuredDepth'), 'pipe')"
                                    [options]="getSortedPipeOptions(rowData, 'weightPerFoot')"
                                    optionLabel="weightPerFoot"
                                    optionValue="id"
                                    formControlName="id"
                                    (onChange)="resetConnection(wellCmpFg, tIdx)"
                                    appendTo="body">
                                  </app-units-select-input>
                                  <app-validation-error [isValid]="isControlInvalid(rowData.get('pipe'), 'weightPerFoot')" [errorMsg]="getControlErrors(rowData.get('pipe'), 'weightPerFoot')"/>
                                </div>
                              </td>
                              <td>
                                <div class="flex w-full items-center gap-1 flex-nowrap">
                                  <app-units-select-input
                                    class="w-full"
                                    [unit]="units.shortLengths"
                                    [unitPrecisionOverrides]="pipeDimensionPrecisionOverrides()"
                                    [readOnly]="userRoles.readOnly"
                                    [placeholder]="getPlaceholderText(rowData.get('pipe').value, 'insideDiameter', rowData.get('bottomMeasuredDepth'), 'pipe')"
                                    [options]="getSortedPipeOptions(rowData, 'insideDiameter')"
                                    optionLabel="insideDiameter"
                                    optionValue="id"
                                    (onChange)="resetConnection(wellCmpFg, tIdx)"
                                    formControlName="id"
                                    appendTo="body">
                                  </app-units-select-input>
                                  <app-validation-error [isValid]="isControlInvalid(rowData.get('pipe'), 'insideDiameter')" [errorMsg]="getControlErrors(rowData.get('pipe'), 'insideDiameter')"/>
                                </div>
                              </td>
                              <td>
                                <div class="flex w-full items-center gap-1 flex-nowrap">
                                  <app-units-select-input
                                    class="w-full"
                                    [unit]="units.shortLengths"
                                    [unitPrecisionOverrides]="pipeDimensionPrecisionOverrides()"
                                    [readOnly]="userRoles.readOnly"
                                    [placeholder]="getPlaceholderText(rowData.get('pipe').value, 'wallThickness', rowData.get('bottomMeasuredDepth'), 'pipe')"
                                    [options]="getSortedPipeOptions(rowData, 'wallThickness')"
                                    optionLabel="wallThickness"
                                    optionValue="id"
                                    formControlName="id"
                                    appendTo="body">
                                  </app-units-select-input>
                                  <app-validation-error [isValid]="isControlInvalid(rowData.get('pipe'), 'wallThickness')" [errorMsg]="getControlErrors(rowData.get('pipe'), 'wallThickness')"/>
                                </div>
                              </td>
                            <td class="text-center opacity-75" title="Drift Diameter">
                              <div class="flex items-center justify-center gap-1">
                                <span>{{ getDriftDiameter(rowData.get('pipe').value) }}</span>
                              </div>
                            </td>
                          </ng-container>
                            <td>
                              <div class="flex w-full items-center gap-1 flex-nowrap">
                                <p-select
                                  filter
                                  filterBy="label"
                                  class="w-full min-w-0"
                                  [disabled]="userRoles.readOnly"
                                  [placeholder]="getPlaceholderText(rowData.get('grade').value, 'name', rowData.get('bottomMeasuredDepth'), 'grade')"
                                  [options]="grades"
                                  formControlName="grade"
                                  appendTo="body">
                                </p-select>
                                @if (rowData.get('grade').value) {
                                  <app-catalog-item-preview
                                    [item]="rowData.get('grade').value"
                                    buttonTooltip="Grade Details"
                                  ></app-catalog-item-preview>
                                }
                                <app-validation-error [isValid]="isControlInvalid(rowData, 'grade')" [errorMsg]="getControlErrors(rowData, 'grade')"/>
                              </div>
                            </td>
                            <td>
                              @if (checkStrengthCalculation(rowData.get('grade'))) {}

                              <div class="flex items-center justify-center">
                                @if (!userRoles.readOnly) {
                                  <p-button 
                                    text
                                    size="small"
                                    [title]="highCollapsePipeLabel == 'API' ? 'To specify Non-API pipe ratings, Strength Calculation option in the Grades catalog must be set to Non-API' : 'To have API calculated ratings, Strength Calculation option in the Grades catalog must be set to API'"
                                    [icon]="checkIfNonApiPipeDataExpanded(wellCmpFg, tIdx) ? 'pi pi-chevron-up' : 'pi pi-chevron-down'" 
                                    (click)="expandNonApiPipeProperties(wellCmpFg, tIdx)" 
                                    label="{{ highCollapsePipeLabel }}">
                                  </p-button>
                                }
                                @if (userRoles.readOnly) {
                                  <i
                                    (click)="expandNonApiPipeProperties(wellCmpFg, tIdx)"
                                    [class]="checkIfNonApiPipeDataExpanded(wellCmpFg, tIdx) ? 'pi pi-chevron-up' : 'pi pi-chevron-down'"
                                  >
                                    {{ highCollapsePipeLabel }}
                                  </i>
                                }
                              </div>
                            </td>
                            <td class="place-items-center">
                              <div class="space-x-1">
                                <p-select
                                  [disabled]="userRoles.readOnly"
                                  tooltip="Filter Connections by Grade"
                                  tooltipPosition="top"
                                  [placeholder]="getConnectionGradeFilterPlaceholder(rowData.get('connection').value?.grade?.name, wellCmpFg, tIdx)"
                                  [options]="getAvailableConnectionGrades(rowData)" 
                                  (onChange)="onConnectionGradeChange($event, wellCmpFg, tIdx, connectionSelect)"
                                  [disabled]="userRoles.readOnly" 
                                  appendTo="body"
                                ></p-select>
                                
                                <p-select 
                                  #connectionSelect
                                  [disabled]="userRoles.readOnly"
                                  [placeholder]="getPlaceholderText(rowData.get('connection').value, 'name', rowData.get('bottomMeasuredDepth'), 'connection', rowData.get('pipe').value?.outsideDiameter)" 
                                  [options]="getConnectionsForCtrl(rowData, wellCmpFg, tIdx)" 
                                  formControlName="connection" 
                                  appendTo="body">
                                </p-select>

                                @if (rowData.get('connection').value) {
                                  <app-catalog-item-preview
                                    [item]="rowData.get('connection').value"
                                    buttonTooltip="Connection Details"
                                  ></app-catalog-item-preview>
                                }
                                
                                <p-button 
                                  text 
                                  size="small" 
                                  severity="danger" 
                                  icon="pi pi-times" 
                                  pTooltip="Remove Connection"
                                  (click)="resetConnection(wellCmpFg, tIdx)">
                                </p-button>
                              </div>
                            </td>
                          <td style="padding-right: 0px; text-align: center;">
                              <p-button text size="small" severity="danger" icon="pi pi-trash" pTooltip="Remove String Section" (click)="onDeleteTubular(wellCmpFg, tIdx)" [disabled]='rowData.parent.length == 1'></p-button>
                          </td>
                        </tr>

                        @if (checkIfNonApiPipeDataExpanded(wellCmpFg, tIdx)) {
                        <tr [formGroupName]="tIdx">
                          <td colspan="11"  [style.backgroundColor]="'rgba(245, 158, 11, 0.08)'">
                            <div class="flex w-full justify-center gap-3 py-1" formGroupName="nonApiPipe">
                              <div class="flex flex-col items-center">
                                <label class="font-medium text-sm text-center">{{ nonApiPipeInputs[0].header }}</label>
                                <div class="flex items-center">
                                  @if (checkStrengthCalculation(rowData.get('grade'))) {
                                    <span class="scale-75">
                                      <p-checkbox tooltipPosition="bottom" pTooltip="Edit Tension" formControlName="tensionEnabled" binary="true"></p-checkbox>
                                    </span>
                                  }
                                  <p-inputNumber class="flex-1" [disabled]="enableHighCollapsePipeRatings(rowData, 'tensionEnabled', rowData.get('grade'))" [minFractionDigits]="1" formControlName="tension"></p-inputNumber>
                                </div>
                              </div>
                              <div class="flex flex-col items-center">
                                <label class="font-medium text-sm text-center">{{ nonApiPipeInputs[1].header }}</label>
                                <div class="flex items-center">
                                  @if (checkStrengthCalculation(rowData.get('grade'))) {
                                    <span class="scale-75">
                                      <p-checkbox tooltipPosition="bottom" pTooltip="Edit Compression" formControlName="compressionEnabled" binary="true"></p-checkbox>
                                    </span>
                                  }
                                  <p-inputNumber class="flex-1" [disabled]="enableHighCollapsePipeRatings(rowData, 'compressionEnabled', rowData.get('grade'))" required [minFractionDigits]="1" formControlName="compression"></p-inputNumber>
                                </div>
                              </div>
                              <div class="flex flex-col items-center">
                                <label class="font-medium text-sm text-center">{{ nonApiPipeInputs[2].header }}</label>
                                <div class="flex items-center">
                                  @if (checkStrengthCalculation(rowData.get('grade'))) {
                                    <span class="scale-75">
                                      <p-checkbox tooltipPosition="bottom" pTooltip="Edit Burst" formControlName="burstEnabled" binary="true"></p-checkbox>
                                    </span>
                                  }
                                  <p-inputNumber class="flex-1" [disabled]="enableHighCollapsePipeRatings(rowData, 'burstEnabled', rowData.get('grade'))" required [minFractionDigits]="1" formControlName="burst"></p-inputNumber>
                                </div>
                              </div>
                              <div class="flex flex-col items-center">
                                <label class="font-medium text-sm text-center">{{ nonApiPipeInputs[3].header }}</label>
                                <div class="flex items-center">
                                  @if (checkStrengthCalculation(rowData.get('grade'))) {
                                    <span class="scale-75">
                                      <p-checkbox tooltipPosition="bottom" pTooltip="Edit Collapse" formControlName="collapseEnabled" binary="true"></p-checkbox>
                                    </span>
                                  }
                                  <p-inputNumber class="flex-1" [disabled]="enableHighCollapsePipeRatings(rowData, 'collapseEnabled', rowData.get('grade'))" required [minFractionDigits]="1" formControlName="collapse"></p-inputNumber>
                                </div>
                              </div>
                              <div class="flex flex-col items-center">
                                <label class="font-medium text-sm text-center">{{ nonApiPipeInputs[4].header }}</label>
                                <p-inputNumber required [minFractionDigits]="1" formControlName="wallToleranceHoop"></p-inputNumber>
                              </div>
                              <div class="flex flex-col items-center">
                                <label class="font-medium text-sm text-center">{{ nonApiPipeInputs[5].header }}</label>
                                <p-inputNumber required [minFractionDigits]="1" formControlName="wallToleranceTriaxialAxial"></p-inputNumber>
                              </div>
                              <div class="flex flex-col items-center">
                                <label class="font-medium text-sm text-center">{{ nonApiPipeInputs[6].header }}</label>
                                <p-inputNumber required [minFractionDigits]="1" formControlName="wallToleranceAxial"></p-inputNumber>
                              </div>
                              <div class="flex flex-col items-center">
                                <label class="font-medium text-sm text-center">{{ nonApiPipeInputs[7].header }}</label>
                                <p-inputNumber required [minFractionDigits]="1" formControlName="wallToleranceBurst"></p-inputNumber>
                              </div>
                              <div class="flex flex-col items-center">
                                <label class="font-medium text-sm text-center">{{ nonApiPipeInputs[8].header }}</label>
                                <p-inputNumber required [minFractionDigits]="1" formControlName="wallToleranceCollapse"></p-inputNumber>
                              </div>
                            </div>
                          </td>
                        </tr>                        }                      </ng-template>
                      </ng-container>
                    </ng-container>
                  </p-table>
                </div>
                </td>
              </tr>
            </ng-template>
          </p-table>
        </ng-container>
      </form>
    </div>
  <br>
</app-tool-loader>
